import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { ApiError } from "./client";

/** Text chyby pro uživatele: kód z ProblemDetails → klíč `error.{code}`, jinak obecná chyba (R-16). */
export function errorText(t: TFunction, error: unknown): string {
  if (error instanceof ApiError && error.code) {
    const key = `error.${error.code}`;
    // Klíče chyb jsou dynamické, proto bez typové kontroly; chybějící klíč spadne na obecnou chybu.
    const text = t(key as never, { ...error.details, defaultValue: "" }) as string;
    if (text) return text;
  }
  return t("error.unexpected");
}

export function useErrorText() {
  const { t } = useTranslation();
  return (error: unknown) => errorText(t, error);
}
